import Container from './container'

export default Container


// WEBPACK FOOTER //
// ./src/care-enrolments/index.js